const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "EPIRB_MODEL_TYPES_RETRIEVED":
            return action.epirbModels;

        default:
            return state;
    }
}
